<template>
  <div>
    <custom-actions show-back>
      <el-form
        class="global-form shoufa-form"
        :model="formData"
        :rules="rules"
        ref="form"
        label-width="160px"
        v-loading="loading"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item prop="typeName" label="类型名称">
              {{ formData.typeName || "" }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :span="24">
          <el-col :span="24">
            <el-form-item label="类型图片" prop="typeImage">
              <div v-if="formData.typeImage" class="images-wrap">
                <el-image
                  style="width: 100%; height: 100%"
                  :src="formData.typeImage"
                  :preview-src-list="[formData.typeImage]"
                  fit="cover"
                />
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>

  </div>
</template>

<script>
export default {
  name: 'GrainTypeeAdd',

  data () {
    return {
      typeArr: [],

      formData: {
        typeId: '',
        typeName: '',
        typeImage: ''
      },
      rules: {
        typeName: [
          {
            required: true,
            message: '请输入类型名称',
            trigger: ['blur', 'change']
          }
        ]
      },
      loading: false,

      dialogVisible: false
    }
  },
  created () {
    if (this.typeId) {
      this.loadData()
    }
  },
  computed: {
    typeId () {
      return this.$route.query.typeId
    }
  },
  methods: {
    loadData () {
      this.loading = true
      this.$axios
        .get(this.$apis.grainType.selectYxOilTypeByTypeId, {
          params: { typeId: this.typeId }
        })
        .then(res => {
          this.formData = res
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
.shoufa-form {
  width: 800px;
}

::v-deep .el-form {
  .el-input-number,
  .el-select,
  .el-cascader,
  .el-date-editor {
    width: 100%;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}
.images-wrap {
  width: 100px;
  height: 100px;
  border: 1px dotted #ddd;
  border-radius: 10px;
  position: relative;
  .close-icon {
    position: absolute;
    top: 0;
    left: 0;
    transform: translate(50%, -50%);
    z-index: 10;
    font-size: 16px;
    color: red;
  }
}
</style>
